/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InvoicePremiumFundingDetailsDto = {
    id: string;
    paymentFrequency: InvoicePremiumFundingDetailsDto.paymentFrequency;
    policyAmount: number;
    policyIssueDate: string;
    policyStartDate: string;
    paymentStartDate: string;
    firstInstalment?: number;
    firstPaymentDueDate?: string | null;
    numberOfPayments?: number;
    regularInstalment?: number;
    regularInstalmentLastDate?: string | null;
    flatInterestRate?: number;
    annualInterestRate?: number;
    interestCharges?: number;
    applicationFee?: number;
    totalAmountPayable?: number;
    premiumTotal?: number;
    depositAmount?: number;
};
export namespace InvoicePremiumFundingDetailsDto {
    export enum paymentFrequency {
        FORTNIGHTLY = 'FORTNIGHTLY',
        MONTHLY = 'MONTHLY',
        ANNUAL = 'ANNUAL',
    }
}

